import { render, staticRenderFns } from "./dialog-adult-volunteer.vue?vue&type=template&id=b2b2fc44&scoped=true"
import script from "./dialog-adult-volunteer.vue?vue&type=script&lang=js"
export * from "./dialog-adult-volunteer.vue?vue&type=script&lang=js"
import style0 from "./dialog-adult-volunteer.vue?vue&type=style&index=0&id=b2b2fc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2fc44",
  null
  
)

export default component.exports